import { useWindowVirtualizer } from '@tanstack/react-virtual';
import classNames from 'classnames';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { PLPCard } from '@/features/product-card/plp-card';
import { generateProductCardProps } from '@/features/product-card/utils/generate-plp-card-props';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import usePLPData from '../_utils/use-plp-data';
import { FIRST_LAZY_PRODUCT_INDEX, PLP_VIRTUAL_GRID_COLUMNS_COUNT } from '../constants';
const VirtualizedPLPGrid = () => {
  const {
    products,
    searchParamsPageNumber
  } = usePLPData();
  const {
    isMobile
  } = useMobileDetect();
  const columnCount = isMobile ? PLP_VIRTUAL_GRID_COLUMNS_COUNT.mobile : PLP_VIRTUAL_GRID_COLUMNS_COUNT.desktop;
  const rowCount = Math.ceil(products.length / columnCount);
  const rowHeight = isMobile ? 301 : 352;
  const rowVirtualizer = useWindowVirtualizer({
    count: rowCount,
    estimateSize: () => rowHeight,
    overscan: PUBLIC_IS_BOT ? rowCount : 1,
    initialRect: {
      width: 900,
      height: PUBLIC_IS_BOT ? rowHeight * rowCount : rowHeight * 2
    }
  });
  const virtualRows = rowVirtualizer.getVirtualItems();
  return <div data-test='plp-grid' style={{
    height: `${rowVirtualizer.getTotalSize()}px`,
    position: 'relative'
  }} data-sentry-component="VirtualizedPLPGrid" data-sentry-source-file="virtualized-plp-grid.tsx">
            {virtualRows.map(virtualRow => {
      const rowStartIndex = virtualRow.index * columnCount;
      const rowProducts = products.slice(rowStartIndex, rowStartIndex + columnCount);
      return <div key={virtualRow.index} className={classNames('absolute left-0 top-0 flex w-full')} style={{
        transform: `translateY(${virtualRow.start}px)`
      }}>
                        {rowProducts.map((product, columnIndex) => {
          const indexInSinglePage = rowStartIndex + columnIndex;
          const cardData = generateProductCardProps(product, indexInSinglePage, searchParamsPageNumber);
          const isLazy = !PUBLIC_IS_BOT && indexInSinglePage >= (isMobile ? FIRST_LAZY_PRODUCT_INDEX.mobile : FIRST_LAZY_PRODUCT_INDEX.desktop);
          return <div key={cardData.id} style={{
            width: `${100 / columnCount}%`,
            height: `${virtualRow.size}px`
          }} className='border-b border-l border-border-gray-light px-1.5 py-1.5 first:pr-0 last:border-l-0 last:pl-0 lg:px-3 lg:py-3'>
                                    <PLPCard {...cardData} isLazy={isLazy} />
                                </div>;
        })}
                    </div>;
    })}
        </div>;
};
export default VirtualizedPLPGrid;